import { ConfirmFillIcon, CrossIcon } from "@t8891/icon";
import { Button } from "@t8891/pc";
import React from "react";
import { AdAgeItem, AdEmailItem, AdRegionItem, SelectSexItem } from "./Smallclothes";
import QRCode from "react-qr-code";
import { host } from "@Services/url";
import Cookies from "js-cookie";
import { useAtom } from "jotai";
import { activityAtom } from "@Lib/jotai/activity";

const CheckPriceItem: React.FC<any> = ({ rosterId, minimumPrice, brandName, kindName, agreeCarResource, data }) => {
  const PHPSESSID = Cookies.get("PHPSESSID");
  return (
    <div className='flex items-center flex-col pt-80 pb-30'>
      <div className='text-18 text-black font-medium flex items-center'>
        <ConfirmFillIcon size={30} fill='#1DBF76' className='mr-6' />
        詢價成功
      </div>

      {!!minimumPrice && (
        <>
          <div className='text-15 text-[#333] mt-20 flex items-center'>
            {brandName} {kindName}
          </div>
          <div className='text-15 text-[#333] mt-10 flex items-center'>
            近期成交中位價<span className='text-[#F87F15]'>{minimumPrice}</span>
          </div>
        </>
      )}
      {data.showActivityQrCode && (
        <div className='flex mt-20 gap-12 h-42'>
          <QRCode
            value={`${host.c}/m/member/index?token=${PHPSESSID}&global_next_spm=2.244.487.1036`}
            style={{ width: "42px", height: "42px" }}
            className='code-view'
          />
          <div className='flex flex-col text-14 text-[#333] h-full justify-between'>
            <p>
              {" "}
              {agreeCarResource === "1"
                ? "業代和車商將為您報價"
                : rosterId
                ? "請留意業代聯絡！"
                : "正在配對在線的業代！"}
            </p>
            <p>行動掃碼登入領紅包 查看新車詢價進度</p>
          </div>
        </div>
      )}
    </div>
  );
};

const AdSuccessItem: React.FC<any> = ({
  kindType,
  minimumPrice,
  recommendPrice,
  rosterId,
  inquiryId,
  brandName,
  kindName,
  agreeCarResource,
  data,
}) => {
  const [activityInfo] = useAtom(activityAtom);
  const isCheckPrice = kindType === "checkPrice";
  const PHPSESSID = Cookies.get("PHPSESSID");

  if (isCheckPrice) {
    return (
      <CheckPriceItem
        minimumPrice={minimumPrice}
        kindName={kindName}
        rosterId={rosterId}
        inquiryId={inquiryId}
        brandName={brandName}
        agreeCarResource={agreeCarResource}
        data
      />
    );
  }

  return (
    <>
      <div className='flex justify-center pt-40 pb-20'>
        <div className='flex gap-14 h-80 pr-34 items-center'>
          <div className={!!recommendPrice ? `h-80` : `h-50`}>
            <ConfirmFillIcon size={30} fill='#1DBF76' />
          </div>
          <div className=''>
            <div className='text-18 text-black font-medium'>詢價成功</div>

            <div className='text-14 text-[#666] mt-4'>
              {agreeCarResource === "1"
                ? "業代和車商將為您報價"
                : rosterId
                ? "請留意業代聯絡！"
                : "正在配對在線的業代！"}
            </div>
          </div>
        </div>
        {data.showActivityQrCode && (
          <div className='ml-34 flex gap-14 pl-68' style={{ borderLeft: "1px solid #E8E8E8" }}>
            <QRCode
              value={`${host.c}/m/member/index?token=${PHPSESSID}&global_next_spm=2.244.487.1036`}
              style={{ width: "80px", height: "80px" }}
              className='code-view'
            />
            <div className='flex'>
              <div className='text-14 text-[#666]  flex justify-center items-center'>
                行動掃碼登入{activityInfo.activityStatus === 1 ? `領紅包` : ""}
                <br /> 查看新車詢價進度
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default AdSuccessItem;
